<img src="/assets/images/login/dialog/close.svg" alt="Cerrar" class="close-icon" (click)="close()">
<div class="title" [innerHTML]="'register_Data17' | i18n"></div>
<button [innerHTML]="'register_Data18' |i18n" (click)="close()" [routerLink]="getRouterLink('Login')"></button>
